import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsBackButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-back-button", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsBackButton;
